import local from './local';
import dev from './dev';
import qa from './qa';
import staging from './staging';
import prod from './prod';
import preProd from './preprod';
import common from './common';

const DEFAULT_ENV = 'prod';
export const getEnvFromUrl = (url) => {
  const { hostname } = new URL(url);
  const host = hostname.split('.');
  const xfinity = host.slice(host.length - 2);
  if (xfinity[0] !== 'xfinity' || xfinity[1] !== 'com' || (host[0] !== 'payments' && host[0] !== 'customer') || host[1] === 'xfinity') {
    return DEFAULT_ENV;
  }
  return host[1].replace(/^pre-?/, 'pre-');
};

const envs = {
  local,
  dev,
  qa,
  staging,
  'pre-prod': preProd,
  prod,
};
const getConfig = () => {
  const env = getEnvFromUrl(window.location);
  return { env, ...(envs[env] || common) };
};
export default getConfig;
